import type { PageRoute } from '../../page-route';
import { PersonnelPage } from './page';
export const route: PageRoute = { path: '/personnel', access: 'authed', Component: PersonnelPage };
